export const normal = function (vertices) {
    return [...vertices];
};
//# sourceMappingURL=normal.js.map